import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import Companies from "assets/navigationIcons/companies.svg?react";
import CreditLimitRequest from "assets/navigationIcons/creditLimitRequests.svg?react";
import DashboardIcon from "assets/navigationIcons/dashboard.svg?react";
import EwalletIcon from "assets/navigationIcons/ewallet.svg?react";

import {
  INVESTOR_ALLOCATIONS,
  INVESTOR_DASHBOARD,
  INVESTOR_MONTHLY_AUM,
  INVESTOR_TRANSACTIONS,
} from "codes";
export const INVESTOR_USER_New = (t: Function, styling: object) => [
  {
    title: t("dashboard"),
    icon: DashboardIcon,
    ...styling,
    link: INVESTOR_DASHBOARD,
  },
  {
    title: "Allocations",
    icon: GpsFixedIcon,
    ...styling,
    link: INVESTOR_ALLOCATIONS,
  },
  {
    title: "Transactions",
    icon: Companies,
    ...styling,
    link: INVESTOR_TRANSACTIONS,
  },
  {
    title: "AUM",
    icon: CreditLimitRequest,
    ...styling,
    link: INVESTOR_MONTHLY_AUM,
  },
  {
    title: "E-wallet",
    icon: EwalletIcon,
    ...styling,
    link: "/e-wallet",
    // permission: PERMISSIONS.show_ewallet,
  },
];
